"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _edenStyleConstants = require('../../../../eden-style-constants');

var _hex2rgba = _interopRequireDefault(require("hex2rgba"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = _interopRequireDefault(require("./shared"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const iconSpecificFontSize = "1.5rem";

const Component = _styledComponents.default.button.withConfig({
  componentId: "sc-1g7hsbc-0"
})(["", ";border:none;border-radius:50%;", ";font-size:", ";padding:0;", ";&[disabled],&[disabled]:hover{background:transparent;color:", ";}"], _shared.default, ({
  size
}) => size === "large" ? `min-width: 3.5rem;
        min-height: 3.5rem;` : size === "small" ? `min-width: ${_edenStyleConstants.spacing32};
          min-height: ${_edenStyleConstants.spacing32};` : `min-width: 2.5rem;
    min-height: 2.5rem;`, iconSpecificFontSize, ({
  inverted,
  active
}) => inverted ? `
        color: ${_edenStyleConstants.white};
        &:hover{ color: ${_edenStyleConstants.white} }
        ${active ? `background: ${_edenStyleConstants.grey40};` : `background: none;

            &:hover {
                background: ${(0, _hex2rgba.default)(_edenStyleConstants.grey40, 0.6)};
            }
      
            &:active {
                background: ${_edenStyleConstants.grey40};
            }`};
       ` : `
        color: currentcolor;
        &:hover { color: currentcolor };
        ${active ? `background: ${_edenStyleConstants.grey3};` : `background: transparent;

            &:hover {
                background: ${(0, _hex2rgba.default)(_edenStyleConstants.grey3, 0.6)};
            }
        
            &:active {
                background: ${_edenStyleConstants.grey3};
            }`};
    `, _edenStyleConstants.grey20);

const Icon = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
  ref: ref,
  as: props.disabled ? "button" : props.href ? "a" : "button"
}), props.children));

Icon.defaultProps = {
  type: "button",
  size: "normal"
};
Icon.displayName = "Icon";
Icon.propTypes = {
  /** The icon */
  children: _propTypes.default.node.isRequired,

  /** Whether to apply styles that show the button as active */
  active: _propTypes.default.bool,

  /** Whether to apply styles that help the button stand out on a dark background */
  inverted: _propTypes.default.bool,

  /** The size of the button */
  size: _propTypes.default.oneOf(["small", "normal", "large"]),

  /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes), if an href is present it will be the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes) */
  type: _propTypes.default.string,

  /** If the button should be disabled */
  disabled: _propTypes.default.bool,

  /** The link that the button should navigate to on click */
  href: _propTypes.default.string
};
var _default = Icon;
exports.default = _default;